module.exports = __webpack_public_path__ + "img/dt-logo-symbol.e68316a7.svg";